import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "main", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--clients--radars--dashboard`
  }

  doRadarDashboard() {
    var html = `<div class="row">
                  <div class="col-8 px-2" data-controller="financials--books--clients--radars--index" data-${this.controllerName}-target="list"></div>
                  <div class="col-4 px-2" data-controller="financials--books--clients--radars--show
                                                           financials--books--clients--radars--save
                                                           financials--books--clients--entities--save" data-${this.controllerName}-target="view"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--clients--radars--main").tableTarget.innerHTML = html)
    }).then(() => {

      controller.getControllerByIdentifier(`financials--books--clients--radars--index`).permission = `financial_client_radar_main`
      controller.getControllerByIdentifier(`financials--books--clients--radars--index`).doIndexListHtml()

      controller.getControllerByIdentifier(`financials--books--clients--radars--save`).permission = `financial_client_radar_main`
      controller.getControllerByIdentifier(`financials--books--clients--radars--save`).gridElement = controller.viewTarget
      controller.getControllerByIdentifier(`financials--books--clients--radars--save`).controllerDashboard = controller

      controller.getControllerByIdentifier(`financials--books--clients--entities--save`).permission = `financial_client_radar_main`
      controller.getControllerByIdentifier(`financials--books--clients--entities--save`).gridElement = controller.viewTarget
      controller.getControllerByIdentifier(`financials--books--clients--entities--save`).controllerDashboard = controller

      controller.getControllerByIdentifier(`financials--books--clients--radars--show`).permission = `financial_client_radar_main`
      controller.getControllerByIdentifier(`financials--books--clients--radars--show`).doViewHtml()

    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
